import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';

export const Counter = styled.div`
    position: absolute;
    left: 30%;
    top: 18px;
    z-index: 111;

    ${media.desktop`
        left: 25%;
    `};

    ${media.tablet`
        left: 10px;
        top: 10px;
    `};
`;

export const CaruselContainer = styled.div`
    position: relative;
    width: 100%;
    margin: 0 auto;
    height: 100%;
    overflow: hidden;
    white-space: nowrap;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const SliderRow = styled.div`
    position: relative;
    max-width: 670px;
    width: 95%;
    margin: 0 auto;

    ${media.tablet`
        width: 100%;
        padding: 0 5px;
    `};
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/Caresel/style.js